import MarkerText from './MarkerText'

type Props = {
  text?: string
}

const AssignmentScopeReminderText = ({ text }: Props) => {
  if (!text) return null
  return (
    <span className='text-info-foreground ml-2 inline-flex items-center gap-0.5 flex-wrap align-middle'>
      &quot;
      <MarkerText text={text} />
      &quot;
    </span>
  )
}

export default AssignmentScopeReminderText
